import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'

export const MeetingDetailRightRail = withSafeSuspense(
  lazy(() => import('./meeting_detail')
    .then((module) => ({ default: module.MeetingDetailRightRail }))
  ), null
)

export const SearchMeetingRightRail = withSafeSuspense(
  lazy(() => import('./search')
    .then((module) => ({ default: module.SearchMeetingRightRail }))
  ), null
)
